import type {} from '@angular/localize/init';

export function maintenanceRouteI18n(): string {
  return 'maintenance';
}
